import { camelToKebabCase } from './camel-to-kebab-case';

/**
 * Generates cssClasses based on the given baseClass and optional classModifiers, which is an object that describes
 *   possible modifiers appended to the baseClass.
 *
 * Example usage:
 * generateCssClasses('zds-button', {
 *     hover: true,
 * }) => 'zds-button zds-button--hover'
 *
 * generateCssClasses('zds-button', {
 *     hover: false,
 *     disabled: true,
 * }) => 'zds-button zds-button--disabled'
 *
 * @param {string} baseClass base class to add modifiers to
 * @param {object} classModifiers modifier object containing modifier keys and boolean values
 *
 * @returns {string}
 */
export function generateCssClasses(baseClass: string, classModifiers: { [key: string]: boolean }): string {
	const cssClasses: string[] = [];

	cssClasses.push(baseClass);

	const kebabModifiers: string[] = Object.keys(classModifiers || {})
		.reduce((kebabModifiers: string[], classModifier) => {
			if (classModifiers[classModifier]) {
				kebabModifiers.push(camelToKebabCase(classModifier));
			}

			return kebabModifiers;
		}, [])
		.map((kebabModifier) => `${baseClass}--${kebabModifier}`);

	return cssClasses.concat(kebabModifiers).join(' ');
}
